import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header'
import { Button, Card, Col, Dropdown, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import ReusableTable from '../../components/ReusableTable';
import { PencilFill, TrashFill } from 'react-bootstrap-icons';

const Roles = () => {
 
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);

    const accessToken = localStorage.getItem('authToken');
    const [name, setName] = useState("");
    const [roles, setRoles] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [editedData, setEditedData] = useState({});
    const [categoryId, setCategoryId] = useState('');
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const columns = [
      { header: "Sr.No", accessor: "serialNumber" },
      { header: "Name", accessor: "name" },
      { header: <div className="text-center">Actions</div>, accessor: null, render: (_, row) => (
            <div className="d-flex justify-content-center align-items-center">
              <Button
                variant="link"
                className="text-primary p-0 mx-2"
                onClick={() => handleOpenEditModal(row)}
                title="Edit"
              >
                EDIT <PencilFill size={16} /> {/* React-Bootstrap Icon for Edit */}
              </Button>
              <Button
                variant="link"
                className="text-danger p-0 mx-2"
                onClick={() => handleOpenDeleteModal(row)}
                title="Delete"
              >
                DELETE <TrashFill size={16} /> {/* React-Bootstrap Icon for Delete */}
              </Button>
            </div>
          )
      },
    ];

    const getRoles = async () => {
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axios.get("role", { headers });
    
          if (response?.data?.status === true) {
            response?.data?.data?.roles.forEach((item, index) => {
              item.serialNumber = index + 1;
            });
    
            setRoles(response?.data?.data?.roles);
            setFilteredData(response?.data?.data?.roles);
          }
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
    };

    const handleOpenAddModal = () => {
      setOpenAddModal(true);
    }

    const handleCloseAddModal = () => {
      setOpenAddModal(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setName(value);
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const addRole = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
    
          const inputData = {
            name: name,
          };
    
          const response = await axios.post("role", inputData, { headers });
    
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            getRoles();
            setOpenAddModal(false);
            setName("");
          }
        } catch (error) {
          if (error?.response) {
            let errorMessage = '';
            if (
              error.response?.status === 406
            ) {
              errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            }
            else if (
              error.response?.status === 412
            ) {
              errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
              errorMessage = error?.response?.data?.error
            }
    
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsLoading(false);
        }
    };

    const handleOpenEditModal = async (data) => {
        setEditedData({
          _id: data?._id,
          name: data.name,
        });
        setOpenEditModal(true);
    };

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
    }

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData((prevState) => ({ ...prevState, [name]: value }));
    };

    const editRoleSubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axios.put("role", editedData, { headers });
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            getRoles();
            setOpenEditModal(false);
          }
        } catch (error) {
          if (error?.response) {
            let errorMessage = '';
            if (
              error.response?.status === 406
            ) {
              errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            }
            else if (
              error.response?.status === 412
            ) {
              errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
              errorMessage = error?.response?.data?.error
            }
    
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsEditBtnLoading(false);
        }
    };

    const handleOpenDeleteModal = async (data) => {
        setOpenDeleteModal(true);
        setCategoryId(data?._id);
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };

    const handleDeleteRole = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
    
          const data = {
            _id: categoryId,
          };
          const response = await axios.delete(`role`, { data, headers });
          if (response?.data?.status === true) {
            toast.success(response?.data?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
            getRoles();
            setOpenDeleteModal(false);
          }
        } catch (error) {
          if (error.response.status === 403) {
            toast.error(error?.response?.data?.message, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
    
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        } finally {
          setIsDeleteBtnLoading(false);
        }
    };

    const handlePageChange = (page) => {
      setPage(page);
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
      setPage(1);
      setRowsPerPage(rowsPerPage);
    };

    // Function to get paginated data
    const getPaginatedData = () => {
      const startIndex = (page - 1) * rowsPerPage;
      
      const endIndex = startIndex + rowsPerPage;

      return filteredData?.slice(startIndex, endIndex);
    };

    useEffect(() => {
        getRoles();
    }, []);

    useEffect(() => {
        const result = roles.filter((item) => {
          return item.name.toLowerCase().match(searchText.toLocaleLowerCase());
        });
        setFilteredData(result);
    }, [searchText]);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
              <div
                className="container shadow-sm"
                style={{ backgroundColor: "white" }}
              >
                <Row className="pt-4">
                  <Col>
                      <h5 className="fw-semibold">ROLE MANAGEMENT</h5>
                  </Col>
                  <hr />
                </Row>

                <Row className='mb-3 justify-content-between'>
                  <Col lg="8">
                    <div className="input-group w-50">
                      <input
                        type="text"
                        className="form-control"
                        value={searchText}
                        onChange={handleSearchChange}
                        placeholder="Search for roles..."
                      />
                      <button className="btn btn-primary" type="button">
                        <i className="ri-search-line"></i> {/* Search Icon */}
                      </button>
                    </div>
                  </Col>
                  <Col lg="3" className='text-end'>
                    <Button
                      variant="primary"
                      onClick={handleOpenAddModal}
                      className="fw-semibold"
                    >
                      <i className="ri-add-line" style={{ marginRight: '5px' }}></i>
                      Add New Role
                    </Button>
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    <ReusableTable 
                      columns={columns}
                      data={getPaginatedData()}
                      currentPage={page}
                      recordsPerPage={rowsPerPage}
                      onPageChange={handlePageChange}
                      totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                      onRecordsPerPageChange={handleRowsPerPageChange}
                      rowKey="serialNumber"
                    />
                  </Col>
                </Row>
              </div>

                {/* <-------------- Add Role Modal --------------> */}
                <Modal show={openAddModal} onHide={handleCloseAddModal} size='md' centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Add New Role</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={addRole}>
                        <Modal.Body>
                            <Form.Group controlId="formCategoryName">
                                <Form.Label className='fw-semibold'>Role Type</Form.Label>
                                <Form.Control
                                    name="name"
                                    className="form-control"
                                    value={name}
                                    type="text"
                                    placeholder="Enter Role Name"
                                    onChange={handleChange}
                                />
                                {/* {errors2?.title && <div className='text-danger' style={{ fontSize : "12px"}}>{errors2?.title}</div>} */}
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type='submit'>
                                {
                                    isLoading ?
                                    <Spinner 
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> : "Add New Role"
                                }
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* <-------------- Edit Role Modal --------------> */}
                <Modal show={openEditModal} onHide={handleCloseEditModal} size='md' centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Update Role</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={editRoleSubmit}>
                        <Modal.Body>
                            <Form.Group controlId="formCategoryName">
                                <Form.Label className='fw-semibold'>Asset Type</Form.Label>
                                <Form.Control
                                    name="name"
                                    className="form-control"
                                    value={editedData?.name}
                                    type="text"
                                    placeholder="Enter Asset Type"
                                    onChange={handleEditChange}
                                />
                                {/* {errors2?.title && <div className='text-danger' style={{ fontSize : "12px"}}>{errors2?.title}</div>} */}
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type='submit'>
                                {
                                    isEditBtnLoading ?
                                    <Spinner 
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> : "Save Changes"
                                }
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* <---------------- Delete Role Modal ------------> */}
                <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className='text-danger'>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete this Role? This action cannot be undone.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDeleteModal}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={handleDeleteRole}>
                            { isDeleteBtnLoading ?
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /> :
                                "Delete Category"                                
                            }
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </React.Fragment>
    )
}

export default Roles